import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { Controller } from "react-hook-form";
import { FormInputProps } from "./FormInputProps";

export const FormInputDropdown = ({
  name,
  control,
  label,
  options = [],
  onChange = () => {},
  required = false,
}: FormInputProps) => {
  const generateSingleOptions = () => {
    return options.map((option) => (
      <MenuItem key={option.value} value={option.value}>
        {option.label}
      </MenuItem>
    ));
  };

  return (
    <FormControl size="small" fullWidth>
      <InputLabel>{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? `${label} is required` : false,
        }}
        render={({ field }) => (
          <Select
            {...field}
            fullWidth
            className="mb-3"
            label={label}
            onChange={(e) => {
              field.onChange(e);
              onChange(e.target.value);
            }}
          >
            {generateSingleOptions()}
          </Select>
        )}
      />
    </FormControl>
  );
};
